import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiCreateSlackCardNotificationsRequest,
  DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest,
  DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest,
  DefaultApiDeleteSlackNotificationSettingForCardRequest,
  DefaultApiGetSlackCardNotificationSettingsRequest,
  DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest,
  DefaultApiGetSlackTeamRequest,
  DefaultApiMoveSlackNotificationSettingForCardRequest,
  DefaultApiSignUpForSlackRequest,
  DefaultApiUpdateSlackNotificationSettingForCardRequest,
  DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest,
  DefaultApiGetSlackChannelRequest,
  DefaultApiGetSlackChannelsWithCursorRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getSlackCardNotificationSettings = async (
  instance: AxiosInstance,
  params: DefaultApiGetSlackCardNotificationSettingsRequest
) => {
  return userApiDefaultApiFactory(instance).getSlackCardNotificationSettings(
    params
  )
}

export const getSlackTeam = async (
  instance: AxiosInstance,
  params: DefaultApiGetSlackTeamRequest
) => {
  return userApiDefaultApiFactory(instance).getSlackTeam(params)
}

export const getSlackNotificationSettingsForPurchaseApplication = async (
  instance: AxiosInstance,
  params: DefaultApiGetSlackNotificationSettingsForPurchaseApplicationRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).getSlackNotificationSettingsForPurchaseApplication(params)
}

export const createSlackNotificationSettingsForPurchaseApplication = async (
  instance: AxiosInstance,
  params: DefaultApiCreateSlackNotificationSettingsForPurchaseApplicationRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).createSlackNotificationSettingsForPurchaseApplication(params)
}

export const updateSlackNotificationSettingForPurchaseApplication = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateSlackNotificationSettingForPurchaseApplicationRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).updateSlackNotificationSettingForPurchaseApplication(params)
}

export const deleteSlackNotificationChannelSettingForPurchaseApplication =
  async (
    instance: AxiosInstance,
    params: DefaultApiDeleteSlackNotificationChannelSettingForPurchaseApplicationRequest
  ) => {
    return userApiDefaultApiFactory(
      instance
    ).deleteSlackNotificationChannelSettingForPurchaseApplication(params)
  }

export const signUpForSlack = async (
  instance: AxiosInstance,
  params: DefaultApiSignUpForSlackRequest
) => {
  return userApiDefaultApiFactory(instance).signUpForSlack(params)
}

export const createSlackCardNotifications = async (
  instance: AxiosInstance,
  params: DefaultApiCreateSlackCardNotificationsRequest
) => {
  return userApiDefaultApiFactory(instance).createSlackCardNotifications(params)
}

export const updateSlackNotificationSettingForCard = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateSlackNotificationSettingForCardRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).updateSlackNotificationSettingForCard(params)
}

export const moveSlackNotificationSettingForCard = async (
  instance: AxiosInstance,
  params: DefaultApiMoveSlackNotificationSettingForCardRequest
) => {
  return userApiDefaultApiFactory(instance).moveSlackNotificationSettingForCard(
    params
  )
}

export const deleteSlackNotificationSettingForCard = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteSlackNotificationSettingForCardRequest
) => {
  return userApiDefaultApiFactory(
    instance
  ).deleteSlackNotificationSettingForCard(params)
}

export const getSlackVersion = async (instance: AxiosInstance) => {
  return userApiDefaultApiFactory(instance).getSlackVersion()
}

export const getSlackChannelsWithCursor = async (
  instance: AxiosInstance,
  params: DefaultApiGetSlackChannelsWithCursorRequest
) => {
  return await userApiDefaultApiFactory(instance).getSlackChannelsWithCursor(
    params
  )
}

export const getSlackChannel = async (
  instance: AxiosInstance,
  params: DefaultApiGetSlackChannelRequest
) => {
  return await userApiDefaultApiFactory(instance).getSlackChannel(params)
}

// Do Not Remove this line ===@import api client===
